import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3 font-heading">{aboutData.title}</h2>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-3xl mx-auto">{aboutData.content}</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {aboutData.highlights.map((h) => (
            <div key={h.label} className="text-center p-5 rounded-lg bg-background-100 border border-background-200/70">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100/70 flex items-center justify-center">
                <i className={`${h.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{h.label}</h3>
              <p className="text-xs text-foreground-500">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}